exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n/*\n * Temporary fix, as BS V4.beta.2 mistakenly removed progress-bar transition.\n * This should be able to be removed once V4.beta.3 is released.\n * And this full component can be moved into the progress.js file\n */\n.progress-bar {\n    transition: width .6s ease;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-fa15f306","scoped":false,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!/home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/progress/progress.vue
// module id = 806
// module chunks = 0